import './EPDashboard.css';

export function EPDashboard() {
  return <h1>Welcome to Education Portal</h1>;
}

export default EPDashboard;
